<!--
  @description 体检报告---详情
  @author xiehan
  @date 2018/12/18
-->
<template>
  <div class="reportDetail reportDetail__content">
    <g-back :history="history"></g-back>
    <div v-text="$t('examinationReport.changeDetail')" class="mb-base detail-title" v-if="type === '2'"></div>
    <el-card class="box-card" v-if="type === '2'">
      <el-form ref="detailForm" :model="detailForm" label-width="100px" input-width="auto">
        <el-form-item :label="$t('examinationReport.updateTime')">
          <span v-text="detailForm.updateTime"></span>
        </el-form-item>
        <el-form-item :label="$t('examinationReport.operator')">
          <span v-text="detailForm.operator"></span>
        </el-form-item>
        <el-form-item :label="$t('examinationReport.ip')">
          <span v-text="detailForm.ip"></span>
        </el-form-item>
        <el-form-item :label="$t('examinationReport.content')">
          <span v-text="detailForm.content"></span>
        </el-form-item>
        <el-form-item :label="$t('examinationReport.rule')">
          <span v-text="detailForm.rule"></span>
      </el-form-item>
      </el-form>
    </el-card>
    <div v-text="$t('examinationReport.alarmStatistics')" class="mt-base mb-base detail-title"></div>
    <el-table
      :data="tableData"
      :cell-style="cellClass"
      style="width: 100%">
      <el-table-column
        prop="alarmType"
        :label="$t('examinationReport.alarmType')">
      </el-table-column>
      <el-table-column
        v-if="type === '1'"
        prop="count"
        :label="$t('examinationReport.alarmCount')">
      </el-table-column>
      <el-table-column
        v-if="type === '2'"
        prop="before20min"
        :label="$t('examinationReport.before20min')">
      </el-table-column>
      <el-table-column
        v-if="type === '2'"
        prop="after20min"
        :label="$t('examinationReport.after20min')">
      </el-table-column>
      <el-table-column
        v-if="type === '2'"
        prop="after40min"
        :label="$t('examinationReport.after40min')">
      </el-table-column>
      <el-table-column
        v-if="type === '2'"
        prop="after60min"
        :label="$t('examinationReport.after60min')">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import examinationReportBiz from '@/logic/statistics/examinationReportBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        history: [],
        select_type: {},
        tableData: [],
        type: '0',
        detailForm: {
          updateTime: '',
          operator: '',
          ip: '',
          content: '',
          rule: ''
        }
      }
    },
    methods: {
      init () {
        this.type = this.$route.query.type
        this.waitType()
      },
      cellClass ({ row, column, rowIndex, columnIndex }) {
        if (((row.count > 0 || row.before20min > 0) && columnIndex === 1) ||
        (row.after20min > 0 && columnIndex === 2) ||
          (row.after40min > 0 && columnIndex === 3) ||
          (row.after60min > 0 && columnIndex === 4)) {
          return 'color:red'
        }
        return ''
      },
      async waitType () {
        await this.dGetDictionaryByCode('alarmType')
        this.select_type = { ...this.dDictionary.alarmType }
        this.getReportInfo()
      },
      setHistory (time) {
        this.history = []
        this.history.push({ name: this.$route.query.type === '1'
          ? `${time}${this.$t('examinationReport.systemExamination')}`
          : this.$t('examinationReport.changeExamination') })
      },
      getReportInfo () {
        examinationReportBiz.getById({ id: this.$route.query.id }).then(data => {
          data.updateTime = TimeFormat.getFormatTime(data.updateTime)
          this.detailForm.updateTime = data.updateTime
          this.detailForm.operator = data.operator
          this.detailForm.ip = data.detail.ip ? data.detail.ip : ''
          this.detailForm.content = data.detail.content ? data.detail.content : ''
          this.detailForm.rule = data.detail.rule ? data.detail.rule : ''
          this.setHistory(data.updateTime)
          if (data.detail.sysAlarmList && data.detail.sysAlarmList.length > 0) {
            data.detail.sysAlarmList.map(item => {
              item.alarmType = this.select_type[item.alarmType]
            })
          }
          this.tableData = data.detail.sysAlarmList
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'reportDetail' && from.name === 'examinationReport') {
          this.init()
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>

<style>
  .reportDetail .el-form-item {
    margin-bottom: 0;
  }
  .reportDetail .detail-title {
    font-weight: bolder;
    font-size: 15px;
  }
</style>